import { AxiosResponse } from "axios";
import { ApiResponse } from "../interfaces/ApiResponse";
import { CodePromoSuggestion, GoogleWalletParams, LoyalityGroup, LoyaltyRestaurantsResponse, PanierDiscount, RestaurantArticlesWithDiscount } from "../interfaces/loyality.interface";
import { authAxios, buildUrl } from "./apiGate";
import { userAxiosInstance } from "./catalogueApi";

export const loyalityApi = {

  fetchLoyaltyRestaurants: async (
    name: string,
    isMarqueBlanche: boolean,
  ) => {

    const params = { name, isMarqueBlanche: String(isMarqueBlanche) }
    const url = buildUrl('/Account/getLoyalityEstablishementByClient', params);
    return authAxios.get<LoyaltyRestaurantsResponse>(url);
  },

  fetchSuggestionDiscountForUser: async (
    establishmentId: string,
  ) => {
    const params = { establishmentId }
    const url = buildUrl('/Account/getSuggestionOfDiscountForUser', params);
    return authAxios.get<PanierDiscount>(url);
  },

  getClientBySecretCode: async (
    secretCode: string,
    restaurantId: number,
  ) => {
    const params = { secretCode, EstablishmentId: String(restaurantId) }
    const url = buildUrl('/Account/getClientBySecretCode', params);
    return authAxios.get(url);
  },

  getRestaurantArticlesWithDiscount: async (
    establishmentId: string,
    qrCodeValue?: string,
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");

    const url = `${baseUrlCatalog}/v1/GetArticlesByEstablishmentIdForFioEat?${qrCodeValue ? `qrCodeValue=${qrCodeValue}&` : ''}establishmentId=${establishmentId}`;

    const response: AxiosResponse<ApiResponse<RestaurantArticlesWithDiscount>> = await userAxiosInstance.get(url);

    return response.data;

  },

  applyPromoCode: async (
    establishmentId: string,
    code: string,
  ) => {
    const params = { establishmentId, code }
    const url = buildUrl('/v1/checkCodePromo', params);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response: AxiosResponse<ApiResponse<CodePromoSuggestion>> = await authAxios.get(url, {
      headers: { "timezone": timezone }
    });

    return response.data;
  },


  addToGoogleWallet: async (params: GoogleWalletParams): Promise<any> => {
    const url = buildUrl('/v1/CreatePass');

    try {
      const response = await userAxiosInstance.post(url, {
        companyId: params.companyId,
        codeFid: params.codeFid?.toString(),
        firstName: params.firstName,
        lastName: params.lastName,
        email: params.email,
        // userId: params.userId,
      });

      return response.data;
    } catch (error) {
      console.error("Failed to create Google Wallet pass:", error);
      throw error;
    }
  },




  // applyFidPromoCode: async (
  //   establishmentId: string,
  //   code: string,
  // ) => {
  //   const params = { establishmentId, code }
  //   const url = buildUrl('/v1/checkCodeAutoLoyalty', params);
  //   const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   const response: AxiosResponse<ApiResponse<CodePromoSuggestion>> = await authAxios.get(url, {
  //     headers: { "timezone": timezone }
  //   });

  //   return response.data;
  // },

  checkLoyaltyGroupForClient: async (establishmentId: string) => {
    const params = { establishmentId, }
    const url = buildUrl('/v1/checkLoyaltyGroupForClient', params);
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response: AxiosResponse<ApiResponse<{ groupAutoLoyalty: LoyalityGroup }>> = await authAxios.get(url, {
      headers: { "timezone": timezone }
    });
    console.log("🚀 ~ checkLoyaltyGroupForClient - response:", response)

    return response?.data?.data?.result?.groupAutoLoyalty;
  },

  addToAppleWallet: async (params: GoogleWalletParams): Promise<any> => {
    const url = buildUrl('/create-apple-pass');

    try {
      const response = await userAxiosInstance.post(url, {
        companyId: params.companyId,
        codeFid: params.codeFid?.toString(),
        firstName: params.firstName,
        lastName: params.lastName,
        email: params.email,
        // userId: params.userId,
      });

      return response.data;
    } catch (error) {
      console.error("Failed to create Apple Wallet pass:", error);
      throw error;
    }
  },
}
